import {SmallDesc} from "@ui/descriptions/SmallDesc";
import {RootIcon} from "@ui/icons/RootIcon";
import {Link} from "react-router-dom";

import styles from "./styles.module.scss";

export const ControlButton = (props) => {
  const {
    txt,
    link,
    iconId,
    type,
    onClick,
    disabled,
    color,
    hoverColor,
    className,
  } = props;

  if (!link) {
    return (
      <button
        className={`${styles.controlButton} ${className}`}
        type={type || "button"}
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
        style={
          !disabled
            ? {
                "borderColor": color || "transparent",
                "color": color || "inherit",
                "--color": color || "transparent",
                "--hoverColor": hoverColor || "var(--white)",
              }
            : {}
        }
      >
        {iconId && (
          <RootIcon
            width={16}
            height={16}
            id={iconId}
          />
        )}

        {txt && (
          <SmallDesc>
            <span>{txt}</span>
          </SmallDesc>
        )}
      </button>
    );
  } else {
    return (
      <Link
        to={"create"}
        className={styles.controlButton}
        disabled={disabled}
        style={{
          "borderColor": color || "var(--black)",
          "color": color || "inherit",
          "--color": color || "transparent",
          "--hoverColor": hoverColor || "var(--white)",
        }}
      >
        {iconId && (
          <RootIcon
            width={16}
            height={16}
            id={iconId}
          />
        )}

        {txt && (
          <SmallDesc>
            <span>{txt}</span>
          </SmallDesc>
        )}
      </Link>
    );
  }
};
